import { TableName } from "../enums/TableName";
import { useGetUserSettings } from "./useGetUserSettings";

export const useGetDefaultTablePreset = (tableName: TableName) => {
  const setting = useGetUserSettings();
  return setting?.tables
    ?.find((table) => table?.name === tableName)
    ?.presets?.find((preset) => preset?.default);
};
